import { cn } from '../../lib/cn';

type Props = {
  sections?: string[];
  active?: string;
  onSelect?: (section: string) => void;
  className?: string;
};

const DEFAULT_SECTIONS = [
  'My Dashboard', 'My Tasks', 'My Recommendations', 'My Alerts',
  'My Activity', 'My Calendar', 'My Approvals', 'My Learning', 'My Bookmarks',
];

export function PersonalWorkspaceNav({
  sections = DEFAULT_SECTIONS,
  active = 'My Dashboard',
  onSelect,
  className,
}: Props) {
  return (
    <nav className={cn('flex flex-wrap gap-1', className)} aria-label="Personal workspace">
      {sections.map((s) => (
        <button
          key={s}
          type="button"
          onClick={() => onSelect?.(s)}
          className={cn(
            'rounded-lg px-3 py-1.5 text-xs font-medium transition',
            active === s
              ? 'bg-brand-600 text-white'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700',
          )}
        >
          {s}
        </button>
      ))}
    </nav>
  );
}
